'use strict';

module.exports = function ColorHelper() {
	const self = this,
		toHex = (s) => {
			let hex = parseInt(s).toString(16);
			if (hex.length === 1) {
				hex = '0' + hex;
			}
			return hex;
		},
		rgbToHex = (r, g, b) => {
			return '#' + toHex(r) + toHex(g) + toHex(b);
		},
		webColors = {
			aliceblue: rgbToHex(240, 248, 255),
			antiquewhite: rgbToHex(250, 235, 215),
			aqua: rgbToHex(0, 255, 255),
			aquamarine: rgbToHex(127, 255, 212),
			azure: rgbToHex(240, 255, 255),
			beige: rgbToHex(245, 245, 220),
			bisque: rgbToHex(255, 228, 196),
			black: rgbToHex(0, 0, 0),
			blanchedalmond: rgbToHex(255, 235, 205),
			blue: rgbToHex(0, 0, 255),
			blueviolet: rgbToHex(138, 43, 226),
			brown: rgbToHex(165, 42, 42),
			burlywood: rgbToHex(222, 184, 135),
			cadetblue: rgbToHex(95, 158, 160),
			chartreuse: rgbToHex(127, 255, 0),
			chocolate: rgbToHex(210, 105, 30),
			coral: rgbToHex(255, 127, 80),
			cornflowerblue: rgbToHex(100, 149, 237),
			cornsilk: rgbToHex(255, 248, 220),
			crimson: rgbToHex(220, 20, 60),
			cyan: rgbToHex(0, 255, 255),
			darkblue: rgbToHex(0, 0, 139),
			darkcyan: rgbToHex(0, 139, 139),
			darkgoldenrod: rgbToHex(184, 134, 11),
			darkgray: rgbToHex(169, 169, 169),
			darkgreen: rgbToHex(0, 100, 0),
			darkgrey: rgbToHex(169, 169, 169),
			darkkhaki: rgbToHex(189, 183, 107),
			darkmagenta: rgbToHex(139, 0, 139),
			darkolivegreen: rgbToHex(85, 107, 47),
			darkorange: rgbToHex(255, 140, 0),
			darkorchid: rgbToHex(153, 50, 204),
			darkred: rgbToHex(139, 0, 0),
			darksalmon: rgbToHex(233, 150, 122),
			darkseagreen: rgbToHex(143, 188, 143),
			darkslateblue: rgbToHex(72, 61, 139),
			darkslategray: rgbToHex(47, 79, 79),
			darkslategrey: rgbToHex(47, 79, 79),
			darkturquoise: rgbToHex(0, 206, 209),
			darkviolet: rgbToHex(148, 0, 211),
			deeppink: rgbToHex(255, 20, 147),
			deepskyblue: rgbToHex(0, 191, 255),
			dimgray: rgbToHex(105, 105, 105),
			dimgrey: rgbToHex(105, 105, 105),
			dodgerblue: rgbToHex(30, 144, 255),
			firebrick: rgbToHex(178, 34, 34),
			floralwhite: rgbToHex(255, 250, 240),
			forestgreen: rgbToHex(34, 139, 34),
			fuchsia: rgbToHex(255, 0, 255),
			gainsboro: rgbToHex(220, 220, 220),
			ghostwhite: rgbToHex(248, 248, 255),
			gold: rgbToHex(255, 215, 0),
			goldenrod: rgbToHex(218, 165, 32),
			gray: rgbToHex(128, 128, 128),
			grey: rgbToHex(128, 128, 128),
			green: rgbToHex(0, 128, 0),
			greenyellow: rgbToHex(173, 255, 47),
			honeydew: rgbToHex(240, 255, 240),
			hotpink: rgbToHex(255, 105, 180),
			indianred: rgbToHex(205, 92, 92),
			indigo: rgbToHex(75, 0, 130),
			ivory: rgbToHex(255, 255, 240),
			khaki: rgbToHex(240, 230, 140),
			lavender: rgbToHex(230, 230, 250),
			lavenderblush: rgbToHex(255, 240, 245),
			lawngreen: rgbToHex(124, 252, 0),
			lemonchiffon: rgbToHex(255, 250, 205),
			lightblue: rgbToHex(173, 216, 230),
			lightcoral: rgbToHex(240, 128, 128),
			lightcyan: rgbToHex(224, 255, 255),
			lightgoldenrodyellow: rgbToHex(250, 250, 210),
			lightgray: rgbToHex(211, 211, 211),
			lightgreen: rgbToHex(144, 238, 144),
			lightgrey: rgbToHex(211, 211, 211),
			lightpink: rgbToHex(255, 182, 193),
			lightsalmon: rgbToHex(255, 160, 122),
			lightseagreen: rgbToHex(32, 178, 170),
			lightskyblue: rgbToHex(135, 206, 250),
			lightslategray: rgbToHex(119, 136, 153),
			lightslategrey: rgbToHex(119, 136, 153),
			lightsteelblue: rgbToHex(176, 196, 222),
			lightyellow: rgbToHex(255, 255, 224),
			lime: rgbToHex(0, 255, 0),
			limegreen: rgbToHex(50, 205, 50),
			linen: rgbToHex(250, 240, 230),
			magenta: rgbToHex(255, 0, 255),
			maroon: rgbToHex(128, 0, 0),
			mediumaquamarine: rgbToHex(102, 205, 170),
			mediumblue: rgbToHex(0, 0, 205),
			mediumorchid: rgbToHex(186, 85, 211),
			mediumpurple: rgbToHex(147, 112, 219),
			mediumseagreen: rgbToHex(60, 179, 113),
			mediumslateblue: rgbToHex(123, 104, 238),
			mediumspringgreen: rgbToHex(0, 250, 154),
			mediumturquoise: rgbToHex(72, 209, 204),
			mediumvioletred: rgbToHex(199, 21, 133),
			midnightblue: rgbToHex(25, 25, 112),
			mintcream: rgbToHex(245, 255, 250),
			mistyrose: rgbToHex(255, 228, 225),
			moccasin: rgbToHex(255, 228, 181),
			navajowhite: rgbToHex(255, 222, 173),
			navy: rgbToHex(0, 0, 128),
			oldlace: rgbToHex(253, 245, 230),
			olive: rgbToHex(128, 128, 0),
			olivedrab: rgbToHex(107, 142, 35),
			orange: rgbToHex(255, 165, 0),
			orangered: rgbToHex(255, 69, 0),
			orchid: rgbToHex(218, 112, 214),
			palegoldenrod: rgbToHex(238, 232, 170),
			palegreen: rgbToHex(152, 251, 152),
			paleturquoise: rgbToHex(175, 238, 238),
			palevioletred: rgbToHex(219, 112, 147),
			papayawhip: rgbToHex(255, 239, 213),
			peachpuff: rgbToHex(255, 218, 185),
			peru: rgbToHex(205, 133, 63),
			pink: rgbToHex(255, 192, 203),
			plum: rgbToHex(221, 160, 221),
			powderblue: rgbToHex(176, 224, 230),
			purple: rgbToHex(128, 0, 128),
			red: rgbToHex(255, 0, 0),
			rosybrown: rgbToHex(188, 143, 143),
			royalblue: rgbToHex(65, 105, 225),
			saddlebrown: rgbToHex(139, 69, 19),
			salmon: rgbToHex(250, 128, 114),
			sandybrown: rgbToHex(244, 164, 96),
			seagreen: rgbToHex(46, 139, 87),
			seashell: rgbToHex(255, 245, 238),
			sienna: rgbToHex(160, 82, 45),
			silver: rgbToHex(192, 192, 192),
			skyblue: rgbToHex(135, 206, 235),
			slateblue: rgbToHex(106, 90, 205),
			slategray: rgbToHex(112, 128, 144),
			slategrey: rgbToHex(112, 128, 144),
			snow: rgbToHex(255, 250, 250),
			springgreen: rgbToHex(0, 255, 127),
			steelblue: rgbToHex(70, 130, 180),
			tan: rgbToHex(210, 180, 140),
			teal: rgbToHex(0, 128, 128),
			thistle: rgbToHex(216, 191, 216),
			tomato: rgbToHex(255, 99, 71),
			turquoise: rgbToHex(64, 224, 208),
			violet: rgbToHex(238, 130, 238),
			wheat: rgbToHex(245, 222, 179),
			white: rgbToHex(255, 255, 255),
			whitesmoke: rgbToHex(245, 245, 245),
			yellow: rgbToHex(255, 255, 0),
			yellowgreen: rgbToHex(154, 205, 50),
			default: ''
		},
		validColor = value => {
			const lc = value.toLowerCase(),
				standardHex = webColors[lc];
			if (standardHex) {
				return standardHex;
			}
			if (/^[a-f0-9][a-f0-9][a-f0-9][a-f0-9][a-f0-9][a-f0-9]$/.test(lc)) {
				return '#' + lc;
			}
			if (/^#[a-f0-9][a-f0-9][a-f0-9][a-f0-9][a-f0-9][a-f0-9]$/.test(lc)) {
				return lc;
			}
			return false;
		};
	self.findColor = prefix => {
		if (!prefix) {
			return false;
		}
		const searchStr = prefix && prefix.toLowerCase(),
			configuredColors = Object.keys(webColors).filter(function (clr) {
				return clr.indexOf(searchStr) === 0;
			}),
			result = (configuredColors.length && configuredColors) || (validColor(prefix) && [validColor(prefix)]);
		return result;
	};
	self.validColor = value => validColor(value);
	self.webColorList = () => {
		return Object.values(webColors).filter(x => x);
	};
};
